import React, { useMemo } from 'react';
import { Button, TreeSelect } from '@panwds/react-ui';
import { PlusIcon } from '@panwds/icons';
import commonStyles from '../../../scss/StatusPageCommon.module.scss';
import { ADD_ICON_SIZE } from '../utils/iconSizes';

/**
 * Multi-select product picker for the "Products And Regions" toolbar. Every product is
 * listed (not just unsubscribed ones) with already-subscribed products pre-checked, so
 * checking/unchecking a product here is the same add/remove action as the product
 * panel's header `x` -- both operate on the same `checkedProducts` state via
 * `onChangeProducts`, which the parent modal reconciles against the previous selection
 * to know which single product was toggled.
 */
const AddProductSelect = ({ products, subscribedProductTypes, onChangeProducts }) => {
    const items = useMemo(() => products.map((p) => ({
        value: p.product_type,
        label: p.product_type,
        searchableText: p.product_type,
    })), [products]);

    return (
        <TreeSelect
            items={items}
            selectedItem={subscribedProductTypes}
            enableSearch
            enableMultiSelect
            hasCheckboxes
            aria-label="Add or remove subscribed products"
            portalProps={{ className: commonStyles.regionTreeFilter }}
            button={(
                <Button appearance="secondary" icon={<PlusIcon size={ADD_ICON_SIZE} aria-hidden="true" />}>
                    Add Product
                </Button>
            )}
            onChange={({ selectedItems }) => onChangeProducts(selectedItems)}
            dataTestId="manage-add-product"
        />
    );
};

export default React.memo(AddProductSelect);
